import Loading from '../../../Common/Loading';
import { BolsaFamiliaRegister } from './BolsaFamiliaRegister';
import { ChildLabor } from './ChildLabor';
import { Homeless } from './Homeless';
import { PeopleRegistered } from './PeopleRegistered';
import { CertificatePresented} from './CertificatePresented';
import { RegistrationStatus } from './RegistrationStatus';
import { useRegistrationStatusChartsDataContext } from './hooks/useRegistrationStatusChartsDataContext';

export const Charts = () => {
    const { isLoading, data } = useRegistrationStatusChartsDataContext();

    if (isLoading ) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <RegistrationStatus />
                <Homeless />
                <BolsaFamiliaRegister />
            </div>
            <div className="charts-side-by-side-dashboards">
                <ChildLabor />
                <PeopleRegistered />
                <CertificatePresented />
            </div>
        </>
    );
};
